import React from 'react';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';
import messages from '../../messages';

const name = <FormattedMessage {...messages.reorderThresholdColumnHeader} />;

export default {
  name,
  getMessageDescriptor: () => messages.reorderThresholdColumnHeader,
  render: (data) => get(data, 'reorderThreshold', 0),
};
